module.exports = __webpack_public_path__ + "media/Greatgreat_grandson.1edd54e4.mp3";